export const defaultItemPriceColor = `rgba(0, 0, 0)`;
